// Utilities for Cart Management
const CART_KEY = "cart_items";


const validateCartItems = cartItems => {
    const validItems = []
    cartItems.forEach(item => {
        if (item?.id) {
            validItems.push(item);
        }
    })
    return validItems;
}

// Save cart items to local storage
export const saveCartToLocalStorage = (cartItems) => {
    localStorage.setItem(CART_KEY, JSON.stringify(validateCartItems(cartItems)));
};

export const emptyCart = () => {
    localStorage.removeItem(CART_KEY);
}

// Load cart items from local storage
export const loadCartFromLocalStorage = () => {
    const storedCart = localStorage.getItem(CART_KEY);
    return storedCart ? JSON.parse(storedCart) : [];
};

// Add or update a product in the cart
export const updateCartItem = (product, quantity) => {
    const cart = loadCartFromLocalStorage();
    const existingItemIndex = cart.findIndex((item) => item.id === product.id);

    if (existingItemIndex !== -1) {
        // Update quantity if product exists
        cart[existingItemIndex].quantity += quantity;
    } else {
        // Add new product to the cart
        cart.push({ ...product, quantity });
    }

    saveCartToLocalStorage(cart);
};

// Remove a product from the cart
export const removeCartItem = (productId) => {
    const cart = loadCartFromLocalStorage().filter((item) => item.id !== productId);
    saveCartToLocalStorage(cart);
};